import {useForm} from "react-hook-form";
import {useState} from "react";
import axios from "axios";
import whitepaperCoverImage from '@/images/whitepaper-cover.png'
import Image from 'next/image';

function download(url, filename) {
    fetch(url).then(function (t) {
        return t.blob().then((b) => {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", filename);
                a.click();
            }
        );
    });
}

export default function WhitepaperCta() {
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(null)
    const {register, handleSubmit, formState: {errors}} = useForm();
    const onSubmit = data => {
        axios.post('/api/subscribe', {
            email: data.email,
            tags: ['Whitepaper']
        })
            .then(function (response) {
                setError(null)
                setSuccess(true)
                download("https://bijlesplein.nl/files/whitepaper.pdf", "whitepaper.pdf")
            })
            .catch(function (error) {
                if (error?.response?.data?.message) {
                    setError(error.response.data.message)
                } else {
                    setError('Er ging iets mis bij het versturen van het formulier. Probeer het later opnieuw.')
                }
            });
    };

    return (
        <div className="bg-white py-16 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="max-w-xl text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                    <div className="flex items-center">
                        <div>
                            <h2 className="inline sm:block">
                                Download onze whitepaper
                            </h2>
                            <h3 className="text-xl sm:text-2xl">over kansenongelijkheid in het onderwijs</h3>
                        </div>
                        <Image src={whitepaperCoverImage} className="w-60 h-auto"/>
                    </div>
                </div>

                {error &&
                    <div className="rounded-md bg-red-50 p-4 mt-4 -mb-5 max-w-md">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 text-red-400">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>

                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-red-800">{error}</h3>
                            </div>
                        </div>
                    </div>
                }

                {success ?
                    <div className="rounded-md bg-green-50 p-4 mt-4 max-w-md">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5" stroke="currentColor"
                                     className="h-5 w-5 text-green-400">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>

                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-green-800">Aanvraag succesvol</h3>
                                <div className="mt-2 text-sm text-green-700">
                                    <p>
                                        De download voor het whitepaper start automatisch. Gebeurt dat niet? <a
                                        href="/whitepaper" target="_blank"
                                        className="font-semibold hover:opacity-80 hover:underline">Klik dan hier</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-10 max-w-md">
                        <div className="flex flex-col sm:flex-row gap-4">
                            <label htmlFor="email-address" className="sr-only">
                                Email
                            </label>
                            <input
                                id="email-address"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                className="min-w-0 flex-auto rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                placeholder="Vul je email in"
                                {...register("email", {required: true})}
                            />
                            <button
                                type="submit"
                                className="flex-none rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Download whitepaper
                            </button>
                        </div>
                        <p className="mt-4 text-sm leading-6 text-gray-900">
                            Wij geven om jouw data. Lees ons{' '}
                            <a href="/files/privacy.pdf" className="font-semibold text-blue-600 hover:text-blue-500">
                                privacybeleid
                            </a>
                            .
                        </p>
                    </form>
                }
            </div>
        </div>
    )
}
